import { FunctionComponent } from "react";

import { faRightToBracket, faRotate } from "@fortawesome/pro-regular-svg-icons";

import { ActionButton } from "../../Shared/Buttons";

import "./UnauthorizedPage.scss";

interface IUnauthorizedPageProps {
  redirectToLogin: () => Promise<void>;
  errors?: any;
}

export const UnauthorizedPage: FunctionComponent<IUnauthorizedPageProps> = (props: IUnauthorizedPageProps) => {
  const redirectToLogin = () => {
    props.redirectToLogin();
  };

  const reloadPage = () => {
    window.location.reload();
  };

  return (
    <div className="page-unauthorized">
      <h1>You could not be signed in.</h1>

      <p>Please sign in or try to reload the page!</p>

      {!!props.errors && <div className="errors">{props.errors.toString()}</div>}

      <div className="buttons">
        <ActionButton
          id="redirect-to-login-button"
          onClick={redirectToLogin}
          label="Redirect to login"
          icon={faRightToBracket}
          showBackground
        />

        <ActionButton id="reload-page-button" onClick={reloadPage} label="Reload page" icon={faRotate} showBackground />
      </div>
    </div>
  );
};
